import axios from '../plugins/axios';

export default {
  loadAccountInfo() {
    const url = `${process.env.VUE_APP_HIWORKS_ACCOUNT_API}/accounts/me`;

    return axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
  },
  /*
  "data": {
    "master_user_no": 5612980,
    "user_id": "marcus",
    "name": "마커스",
    "company_num": "gm1202361",
    "joindate": "2000-01-01",
    "position_no": 1725,
    "job_no": 61400,
    "email": "jhkim@gabia.com",
    "phone": "02-555-1234",
    "cell": "010-3333-5555",
    "zip_code": "13625",
    "address": "부산 해운대구 APEC로 30 (우동, 벡스코제2전시장)",
    "birthday": "2017-05-31",
    "birthday_type": "S",
    "introduce": "하이^^^^^^^^ssssss",
    "cell_visible": "Y",
    "address_visible": "Y",
    "email_visible": "N",
    "birth_visible": "Y",
    "company_visible": "N",
    "intro_visible": "Y",
    "joindate_visible": "N",
    "nodes": [
      {
        "id": 2966,
        "name": "12",
        "full_name": "12345|12"
      },
      {
        "id": 80756,
        "name": "하위조직1",
        "full_name": "12345|12|개발2팀|12321412|하위조직1"
      },
      {
        "id": 129518,
        "name": "CS 테스트 조직",
        "full_name": "12345|CS 테스트 조직"
      }
    ],
    "profile_image": {
      "small": "https://account-api.devoffice.hiworks.com/profile-image/users/5612980?filter[size]=75",
      "normal": "https://account-api.devoffice.hiworks.com/profile-image/users/5612980?filter[size]=150"
    }
  }
  */
  // 겸직자 정보 조회
  loadMultiAccounts() {
    const url = `${process.env.VUE_APP_HIWORKS_AUTH_API}/multi-positions`;

    return axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });
  },
  switchMultiAccount(userNo) {
    const url = `${process.env.VUE_APP_HIWORKS_AUTH_API}/multi-positions/switch-account`;

    return axios.post(
      url,
      { user_no: userNo },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      },
    );
  },
};
